import React, { Component } from 'react'
import Link, { withPrefix } from 'gatsby-link'
import Img from 'gatsby-image'
import { translate } from 'react-i18next'

import { Row, Column } from '../../global/grid/grid'
import { H1 } from '../../global/typography/typography'
// import Image from '../../global/media/Image';

import NomBackground from '../../../static/svgs/nominate-background.svg'
import { ColorBlock, NominateCityButton, Intro } from './styled-components'

class PizzaAd extends Component {
  constructor (props) {
    super(props)
    this.scrollTrigger = 0
    this.latestKnownScrollY = 0
    this.ticking = false

    // bind events to context
    this.handleScroll = this.handleScroll.bind(this)
    this.setScrollTrigger = this.setScrollTrigger.bind(this)

    this.state = {
      animateIn: false
    }
  }
  componentDidMount () {
    document.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.setScrollTrigger)
    setTimeout(() => {
      this.setScrollTrigger()
    }, 1)
  }
  componentWillUnmount () {
    document.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.setScrollTrigger)
  }
  setScrollTrigger () {
    const scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop
    const pizzaAdTop = this.pizzaAdHolder.getBoundingClientRect().top
    this.scrollTrigger = pizzaAdTop + scrollTop
  }
  handleScroll (e) {
    this.latestKnownScrollY = window.scrollY ? window.scrollY : window.pageYOffset
    this.requestTick()
  }
  requestTick () {
    if (!this.ticking) {
      requestAnimationFrame(this.update.bind(this))
    }
    this.ticking = true
  }
  update () {
    this.ticking = false
    // const animateInCalc = (this.latestKnownScrollY + window.innerHeight - 200) > this.scrollTrigger;
    const animateInCalc = (this.scrollTrigger - this.latestKnownScrollY) < (window.innerHeight - (window.innerHeight * 0.2))
    // console.log(animateInCalc);
    if (animateInCalc !== this.state.animateIn && animateInCalc === true) {
      this.setState(
        {
          animateIn: true
        }
      )
    }
  }
  gaOrderNowCLicked () {
    window.dataLayer.push({
      'event': 'ordernow:click',
      'nav': 'body',
      'navItem': 'Order Now'
    })
  }
  render () {
    const { data, imageDictionary, t } = this.props
    return (
      <div ref={(div) => this.pizzaAdHolder = div}>
        <Row>
          <Column cw={10} offset={1}>
            <Intro>{t('pizzaAd.intro')}</Intro>
          </Column>
          <Column cw={4} offset={1} style={{ position: 'relative', alignItems: 'flex-start' }}>
            <ColorBlock>
              <div className='stripesHolder'>
                <div className='stripes' />
              </div>
              <div className={`imageHolder ${this.state.animateIn ? '' : 'passive'}`}>
                <img src={withPrefix('/pizza-paddle.png')} alt='Pizza Paddle' />
              </div>
            </ColorBlock>
          </Column>
          <Column cw={5} offset={2} style={{ display: 'flex', flexDirection: 'column' }}>
            <H1>{t('pizzaAd.copy')}</H1>
            <a href={t('pizzaAd.link')} target='_blank' onClick={this.gaOrderNowCLicked}>
              <NominateCityButton>
                <NomBackground />
                <div className='buttonText'>
                  {t('pizzaAd.orderCTA')}
                </div>
              </NominateCityButton>
            </a>
          </Column>
        </Row>
      </div>
    )
  }
}

export default translate()(PizzaAd)



// WEBPACK FOOTER //
// ./src/components/modules/PizzaAd/PizzaAd.js